<template>

  <modalo
    :title="title"
    type="mini"
    @hideModal="hideModal()"
    :modaloWatch="() => initIntegration">

    <IndeedForm
      v-if="keyName === 'indeed'"
      v-model="integration.settings"
      :validateErrors="validateErrors" />
    
    <CathoForm
      v-if="keyName === 'catho'"
      v-model="integration.settings"
      :validateErrors="validateErrors" />

    <LinkedInLimitedListingsForm
      v-if="keyName === 'linkedin_limited_listings'"
      v-model="integration.settings"
      :validateErrors="validateErrors" />

    <div
      v-if="errorMessage"
      class="alert alert-warning mt-3">
      {{ errorMessage }}
    </div>

    <template slot="footer">
      <div
        :class="{'box-loading': loading}">
        <button
          type="button"
          class="btn btn-primary"
          @click="save()">{{ $t('Save') }}</button>
        <button
          type="button"
          class="btn btn-light"
          @click="hideModal()">{{ $t('Cancel') }}</button>
      </div>
    </template>

  </modalo>

</template>

<script>
import IndeedForm from './IndeedForm'
import CathoForm from './CathoForm'
import LinkedInLimitedListingsForm from './LinkedInLimitedListingsForm'

export default {
  name: 'IntegrationForm',
  components: {
    IndeedForm,
    CathoForm,
    LinkedInLimitedListingsForm
  },
  props: {
    keyName: {
      type: String
    },
    title: {
      type: String
    },
    initIntegration: {
      type: [Object, null]
    }
  },
  data () {
    return {
      integration: this.$clone(this.initIntegration),
      loading: false,
      validateErrors: {},
      errorMessage: null
    }
  },
  created () {
  },
  methods: {
    update () {
    },
    save () {
      this.loading = true

      this.$store
      .dispatch('replaceIntegration', {
        ...this.integration,
        key: this.keyName
      })
      .then(result => {
        this.hideModal()
        this.$emit('saved')
      })
      .catch(err => {
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
        if (err.response.data.name === 'UnprocessableEntity') {
          this.errorMessage = err.response.data.message
        }
      }).finally(() => {
        this.loading = false
      })
    },
    hideModal () {
      this.$emit('hideModal')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Integration/IntegrationForm.vue